import styled from 'styled-components';

import { animation } from '../../animations/styles';
import theme from '../../theme';

export const Header = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: ${theme.layout.gutter} 0 ${theme.layout.gutter} 0;
`;

export const Name = styled.div`
    font-family: ${theme.typography.fontFamilyHeader};
    font-weight: 400;
    font-size: 48px;
    letter-spacing: 1.4px;
    color: ${theme.colors.primary};
    opacity: 0;

    margin: ${theme.layout.gutter} 0 8px 0;

    animation: ${props => animation(props.animation)};

    @media ${theme.mediaQueries.xsmall} {
        margin: 20px 0 12px 0;
    }
`;

export const Caption = styled.div`
    font-family: ${theme.typography.fontFamilyHeader};
    font-size: 18px;
    letter-spacing: 1px;
    color: ${theme.colors.secondary};
    margin: 0 0 36px 0;
    opacity: 0;

    animation: ${props => animation(props.animation)};
`;

export const Description = styled.div`
    font-family: ${theme.typography.fontFamilyBody};
    letter-spacing: 0.5px;
    color: ${theme.colors.secondary};
    margin: 0 ${theme.layout.gutter} 5px ${theme.layout.gutter};
    opacity: 0;

    animation: ${props => animation(props.animation)};
`;

export const SocialLinks = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;

    margin: 0 ${theme.layout.gutter};
    opacity: 0;

    animation: ${props => animation(props.animation)};
`;

export const Logo = styled.div`
    height: 40px;
    width: 40px;
    margin: 10px;
    opacity: 0.7;

    cursor: pointer;

    transition:
        transform 300ms ${theme.animations.pop},
        opacity 300ms;

    &:hover {
        transform: scale(1.2);
        opacity: 1;
    }
`;
